// extracted by mini-css-extract-plugin
export default {"message":"AF8FO4L3"};